<template>
  <LayoutHeader main="register" :register="false" ref="layout" :loadingOverlay="loadingOverlay" :me="me">
    <article>
      <template  v-if="step == 'input'">
        <h1 class="text-center mb-5">登録してゲームの続きを保存しよう</h1>
        <div class="mb-4 text-center">
          <button class="gsi-material-button" @click.prevent="google()">
            <div class="gsi-material-button-state"></div>
            <div class="gsi-material-button-content-wrapper">
              <div class="gsi-material-button-icon">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                  <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                  <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                  <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                  <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                  <path fill="none" d="M0 0h48v48H0z"></path>
                </svg>
              </div>
              <span class="gsi-material-button-contents" style="font-weight: 700; color: #525252">Google アカウントで登録</span>
              <span style="display: none;">Sign in with Google</span>
            </div>
          </button>
        </div>
        <form @submit.prevent="registerConfirm()">
          <hr class="mb-4 w-100" />
          <div class="text-center mb-3">
            または、メールアドレスで登録
          </div>
          <div class="mb-3">
            <label for="email" class="form-label fw-bold">メールアドレス</label>
            <input type="email" class="form-control email" :class="{'is-invalid': alreadyRegistered === true}" ref="registerEmail" v-model="registerEmail" placeholder="address@example.com" autofocus required />
            <div class="invalid-feedback">
              登録済みのメールアドレスです。<a href="javascript:;" @click="$refs.layout.showLoginModal()" class="text-decoration-underline">ログインする</a>
            </div>
          </div>
          <div class="mb-3">
            <label for="password" class="form-label fw-bold">パスワード</label>
            <input :type="passwordType" class="form-control email" id="password" ref="registerPassword" v-model="registerPassword" placeholder="8文字以上を入力" autocomplete="new-password" minlength="8" @focus="passwordFocus()" @blur="passwordBlur()" required />
          </div>
          <div class="mb-3">
            <button type="submit" class="btn btn-danger w-100 fw-bold">認証コードを送信</button>
          </div>
          <hr class="mb-3" />
          <div class="login">
            アカウントをすでにお持ちの場合は、<a href="javascript:;" @click="$refs.layout.showLoginModal()" class="text-decoration-underline">ここからログインしてください</a>
          </div>
        </form>
      </template>
      <div v-if="step == 'confirm'">
        <h1 class="text-center">認証コードを入力</h1>

        <div class="text-center mb-4 sendMail">
        「{{ registerEmail }}」へ認証コードを送信しました。
        </div>

        <div class="mb-3 d-flex justify-content-center codes" ref="registerCompleteCodeParent">
          <HOtpInput
            :length="4" 
            type="tel" 
            @on-finish="registerCompleteCodeFinish"
            @on-change="registerCompleteCodeChange" 
            :outlined="false"
            ref="registerCompleteCode"
            :only-number="true"
          />
        </div>
        <div class="mb-3 text-center" v-if="registerCompleteCodeMissMatch">
          <div class="alert alert-danger">
            入力された認証コードが一致しません
          </div>
        </div>
        <div class="mb-4 d-flex justify-content-center" v-if="registerCompleteCode.length == 4">
          <button type="button" class="btn btn-danger fw-bold w-75" @click.prevent="registerSubmit()">次へ</button>
        </div>
        <div class="mb-4 d-flex justify-content-center" v-else>
          <button type="button" class="btn btn-danger fw-bold w-75" disabled @click.prevent="registerCompleteCodeSubmit()">コードを入力して下さい</button>
        </div>
        <div class="text-center">
          <a href="javascript:;" class="text-decoration-underline" @click.prevent="backInput()">メールアドレスを修正</a>
        </div>
      </div>
      <div v-if="step == 'complete'">
        <h1 class="text-center">登録が完了しました</h1>

        <div v-if="me && me.google" class="mb-4 text-center">
          <p>選択した Google アカウントの「{{ me.email }}」を同じメールアドレスのTapFunアカウントとして作成しました。</p>
          <p>今後は、この Google アカウントでログインすることができます。</p>
        </div>
        <div v-if="me" class="mb-4 text-center">
          <p>登録したメールアドレス: {{ me.email }}</p>
        </div>

        <div v-if="lastApp" class="mb-5 text-center">
          <router-link class="btn btn-light px-4" :to="{ name: 'Play', params: { app: lastApp.path }}">プレイ中のゲームへ戻る</router-link>
        </div>
        <div v-else="lastApp" class="mb-5 text-center">
          <router-link class="text-decoration-underline" :to="{ name: 'Top' }">ホームへ</router-link>
        </div>
      </div>
    </article>
    <Modal v-model="duplicateRegisterModal" title="別で連携済みのアカウントが存在します">
      <div class="text-center">
        <div class="mb-3">
          <div class="alert alert-danger">
            <p>選択した Google アカウントの「{{ this.registerEmail }}」はすでに TapFun に登録されており、別の Google アカウントと連携されているため、TapFun への登録またはログインはできませんでした。</p>
            <p class="mb-0">メールアドレスとパスワード、もしくは連携済みの Google アカウントで<a href="javascript:;" @click="$refs.layout.showLoginModal()" class="text-decoration-underline">ログイン</a>して下さい。</p>
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-dark" @click.prevent="duplicateRegisterModal = false">閉じる</button>
        </div>
      </div>
    </Modal>
  </LayoutHeader>
</template>

<script>
import { nextTick } from 'vue';
import baseMixin from './base'
import { HOtpInput } from "@healerlab/vue3-simple-otp-input";

export default {
  mixins: [
    baseMixin,
  ],
  components: {
    HOtpInput,
  },
  data () {
    return {
      titlePrefix: '登録',
      registerEmail: this.$route.query.debug ? 'a+registertest' + (new Date).getTime() + '@tapfun.co.jp' : '',
      registerPassword: this.$route.query.debug ? 'testtest' : '',
      passwordType: 'password',
      step: this.$route.query.step ?? 'input',
      submited: false,
      alreadyRegistered: false,
      registerCompleteCode: '',
      registerCompleteCodeMissMatch: false,
      duplicateRegisterModal: false,
    }
  },
  methods: {
    _mounted() {
      nextTick(() => {
        setTimeout(() => {
          if (this.$refs.registerEmail) {
            this.$refs.registerEmail.focus();
          }
        }, 100);
      });
    },
    _meSeted(me, session) {
      if (session && session.flash && session.flash.type == 'duplicate') {
        this.registerEmail = session.flash.email;
        this.duplicateRegisterModal = true;
      }
    },
    confirm() {
    },
    backInput() {
      this.step = 'input';
    },
    registerConfirm() {
      this.registerCompleteCodeMissMatch = false;
      this.loadingOverlay = true;
      this.registerCompleteCode = '';
      this.axios({
        method: 'post',
        url: '/register/confirm',
        data: {
          email: this.registerEmail,
          password: this.registerPassword,
        },
      }).then((r) => {
        if (r.data.error == 'alreadyRegistered') {
          this.alreadyRegistered = true;
          this.loadingOverlay = false;
          return;
        }
        this.step = 'confirm';
        this.loadingOverlay = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.registerCompleteCodeParent.querySelector('input').focus();
          }, 300);
        });
      }).catch((e) => {
        console.error(e);
        this.loadingOverlay = false;
        alert('通信エラー');
      });
    },
    registerCompleteCodeChange(code) {
      this.registerCompleteCode = code;
    },
    registerCompleteCodeFinish(code) {
      this.registerCompleteCode = code;
      this.registerSubmit();
    },
    registerSubmit() {
      const data = {};
      data.email = this.registerEmail;
      data.password = this.registerPassword;
      data.code = this.registerCompleteCode;
      this.loadingOverlay = true;
      this.axios({
        method: 'post',
        url: '/register',
        data: data,
      }).then(async (r) => {
        this.loadingOverlay = false;
        if (r.data.error == 'codeMissMatch') {
          this.registerCompleteCodeMissMatch = true;
          this.$refs.registerCompleteCode.clear();
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.registerCompleteCodeParent.querySelector('input:first-child').focus();
            }, 300);
          });
          return;
        }
        if (r.data.error == 'alreadyRegistered') {
          this.$refs.registerCompleteCode.clear();
          alert('すでに登録されています。');
          return;
        }
        await this.session(false);
        this.step = 'complete';
      }).catch((e) => {
        alert('通信エラーが発生しました。再度お試しください。');
        console.log(e);
        this.loadingOverlay = false;
      });
    },
    google() {
      window.open('/player/login/google?context=register', '_self');
    },
    passwordFocus() {
      this.passwordType = 'text';
    },
    passwordBlur() {
      this.passwordType = 'password';
    },
  },
}
</script>
